import React from "react";
import { CheckIcon } from "lucide-react";
import { BuyButton } from "./BuyButton";
import { CountdownOffer } from "./CountdownOffer";
import { PaymentMethods } from "./PaymentMethods";
import { PRICE, PRICE_OLD } from "../lib/data";
const ORDER_ITEMS = [{
  label: "13 PDFs / Checklists de consulta rápida",
  price: "$18.990"
}, {
  label: "5 Plantillas Word editables",
  price: "$12.990"
}, {
  label: "7 Excel funcionales con fórmulas",
  price: "$14.990"
}, {
  label: "3 Ebooks de casos clínicos",
  price: "$9.990"
}, {
  label: "8 Bonos extra",
  price: "GRATIS"
}];
export function FinalOffer() {
  return <section id="comprar" className="scroll-mt-4 px-4 pt-12" data-id="element-75" data-mp="20334nlaxcg2b">
      <div className="mx-auto max-w-md" data-id="element-76" data-mp="1v5jscqxsedd0">
        <div className="overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-xl" data-id="element-77" data-mp="1v6mk112xojtz">
          <div className="bg-teal-600 px-5 py-4 text-center" data-id="element-78" data-mp="295ukdxau1xzr">
            <p className="font-display text-lg font-extrabold text-white" data-id="element-79" data-mp="246hxxdnvisxp">
              Megapack Fisio Eficiente
            </p>
            <p className="text-sm text-teal-100" data-id="element-80" data-mp="1qqnsl6t67fb">Oferta lanzamiento, cupos limitados</p>
          </div>

          <div className="p-5" data-id="element-81" data-mp="6pbenu067er3">
            <CountdownOffer data-id="element-82" data-mp="6qd26xydhtpp" />

            {/* Resumen del pedido */}
            <div className="mt-5" data-id="element-83" data-mp="bm1t6cwbu2ae">
              <p className="mb-2 text-sm font-extrabold uppercase tracking-wide text-slate-500" data-id="element-84" data-mp="bpzbiwb2ypt8">
                Resumen del pedido
              </p>
              <ul className="divide-y divide-slate-100 rounded-2xl border border-slate-200" data-id="element-85" data-mp="knjhujnsvcap">
                {ORDER_ITEMS.map(it => <li key={it.label} className="flex items-center gap-2 px-3.5 py-2.5" data-id="element-86" data-mp="pl1h1ic0md5i">
                    <CheckIcon className="h-4 w-4 shrink-0 text-teal-600" data-id="element-87" data-mp="zdh2ipmitjv5" />
                    <span className="flex-1 text-[13px] leading-tight text-slate-700" data-id="element-88" data-mp="14ck6e6qrlk1j">
                      {it.label}
                    </span>
                    <span className={`text-[13px] font-bold ${it.price === "GRATIS" ? "text-teal-600" : "text-slate-400 line-through"}`} data-id="element-89" data-mp="18ef3t05krda1">
                      {it.price}
                    </span>
                  </li>)}
              </ul>
            </div>

            {/* Precio */}
            <div className="mt-5 flex items-end justify-center gap-3" data-id="element-90" data-mp="39fbobd52flpu">
              <span className="text-lg font-bold text-slate-400 line-through" data-id="element-91" data-mp="3o4845wdd6310">
                {PRICE_OLD}
              </span>
              <span className="font-display text-4xl font-extrabold text-slate-900" data-id="element-92" data-mp="3j550af94e2um">
                {PRICE}
              </span>
            </div>
            <p className="mt-1 text-center text-sm font-semibold text-teal-600" data-id="element-93" data-mp="3t446zsabroez">
              Ahorras un 66% hoy · Pago único
            </p>

            <div className="mt-5" data-id="element-94" data-mp="22sg2z0rzheww">
              <BuyButton data-id="element-95" data-mp="22tr9v9gq72s8" />
            </div>
            <PaymentMethods data-id="element-96" data-mp="1yqux3zdva0w7" />
          </div>
        </div>
      </div>
    </section>;
}